import {
  FETCH_CLIP_ID_REQUEST,
  FETCH_CLIP_ID_SUCCESS,
  UPDATE_CLIP_ID_SUCCESS,
  UPDATE_CLIP_ID_ERROR,
} from './actionTypes'

const initialState = {
  isLoading: true,
  clip: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CLIP_ID_REQUEST:
      return {
        ...state,
        isLoading: true,
      }

    case FETCH_CLIP_ID_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        clip: action.data,
      }
    }

    case UPDATE_CLIP_ID_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        clip: action.data,
      }
    }

    case UPDATE_CLIP_ID_ERROR: {
      const { error } = action

      return {
        ...state,
        isLoading: false,
        error,
      }
    }

    default:
      return state
  }
}
